export const TALK_TO_HUMAN_BOOKING_URL =
  (process.env.REACT_APP_TALK_TO_HUMAN_BOOKING_URL || 'https://calendar.app.google/x1MjojXPsqyjJddV6').trim();

export const TALK_TO_HUMAN_BOOKING_EMBED_URL =
  (
    process.env.REACT_APP_TALK_TO_HUMAN_BOOKING_EMBED_URL ||
    'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1w3pZ__WlgyU4SRZnWoLXgXaNs8-Olgvft6MriguPS2TnquWiDw7VMZ_k3WN66fMN6DfxX4Tbk?gv=true'
  ).trim();

export const TALK_TO_HUMAN_SUBSCRIBE_URL =
  (process.env.REACT_APP_TALK_TO_HUMAN_SUBSCRIBE_URL || 'https://www.quantchecklabs.com/subscribe').trim();

export const CONTACT_TEAM_WHATSAPP_DEEP_LINK =
  (
    process.env.REACT_APP_CONTACT_TEAM_WHATSAPP_DEEP_LINK ||
    'https://wa.me/message/J33PB27SABONO1'
  ).trim();

export const CONTACT_TEAM_WHATSAPP_URL =
  (
    process.env.REACT_APP_CONTACT_TEAM_WHATSAPP_URL ||
    'https://wa.me/message/J33PB27SABONO1'
  ).trim();

export const CONTACT_TEAM_X_DM_DEEP_LINK =
  (
    process.env.REACT_APP_CONTACT_TEAM_X_DM_DEEP_LINK ||
    'https://twitter.com/messages/compose?recipient_id=1677143588235362304'
  ).trim();

export const CONTACT_TEAM_X_DM_URL =
  (
    process.env.REACT_APP_CONTACT_TEAM_X_DM_URL ||
    'https://twitter.com/messages/compose?recipient_id=1677143588235362304'
  ).trim();
